import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=8be5c570&scoped=true&"
import script from "./shopping-cart.vue?vue&type=script&lang=js&"
export * from "./shopping-cart.vue?vue&type=script&lang=js&"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&lang=less&"
import style1 from "./shopping-cart.vue?vue&type=style&index=1&id=8be5c570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be5c570",
  null
  
)

export default component.exports